module.exports = __webpack_public_path__ + "static/img/card1.67eae79d.png";